import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  BalanceChartByClientId_clientCharts,
  BalanceChartByClientId_clientChartsVariables
} from '../../../_generated/BalanceChartByClientId_clientCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query BalanceChartByClientId_clientCharts($id: ID!, $precision: Precision!) {
  charts {
    byClientId(id: $id) {
      id: clientId
      balance(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = BalanceChartByClientId_clientCharts
export type V = BalanceChartByClientId_clientChartsVariables
export type R = Q['charts']['byClientId']['balance']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byClientId.balance)
}

export function Use(clientId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: clientId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
